import React from 'react';

import classNames from 'classnames';

import styles from './header-tab-bar.less';

interface HeaderTabProps extends React.HTMLAttributes<HTMLAnchorElement> {
  isActive?: boolean;
  iconName?: string;
  url?: string;
}

export const HeaderTab: React.StatelessComponent<HeaderTabProps> = ({
  isActive,
  children,
  className,
  iconName,
  url,
  ...props
}) => (
  <a
    className={classNames(
      styles.headerTab,
      { [styles.active]: isActive },
      className,
    )}
    href={url}
    {...props}
  >
    {iconName && (
      <div className={styles.icon}>
        <span
          className={classNames('icon-sm', `icon-${iconName}`, styles.iconSpan)}
        />
      </div>
    )}
    {children}
  </a>
);

interface HeaderTabBarProps extends React.HTMLAttributes<HTMLDivElement> {}

export const HeaderTabBar: React.StatelessComponent<HeaderTabBarProps> = ({
  children,
  ...props
}) => (
  <div className={styles.headerTabBar} {...props}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/header-tab-bar.tsx